<div class="main-scanner">
    <section class="header"></section>
    <video id="video" class="qr-scanner" height="600px" autoplay muted="true"></video>
    <section class="actions"></section>
</div>